import Component from '../core/Component'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'
import PositionObserver from '../meta/PositionObserver'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    PINNED: 'is-pinned'
}

export default class FixedFooter extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            footer: null,
            wrapper: null
        }

        this.isPinned = false
        this.isActive = false
        this.isForbidden = false

        this.enquireHandler = {
            match: ::this.match,
            unmatch: ::this.unmatch
        }

        this.state = {
            height: 0
        }
    }

    prepare() {
        this.resize()
        this.check()

        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)

        EventBus.on('swup:aftercontentchange', this.handleResize)
        enquire.register(queries.mediumMax, this.enquireHandler)
    }

    destroy() {
        EventBus.off('swup:aftercontentchange', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
        enquire.unregister(queries.mediumMax, this.enquireHandler)
    }

    handleResize = () => {
        this.resize()
        this.check()
    }

    handleScroll = ({ offset }) => {
        if (!this.isPinned) {
            return
        }

        this.render(offset.y)

    }

    match() {
        this.isForbidden = true
        this.check()
    }

    unmatch() {
        this.isForbidden = false
    }

    resize() {
        this.state.height = this.ref.wrapper.getBoundingClientRect().height
        this.state.limit = Scroll.getLimit()
        this.render(Scroll.getScroll().y)
    }

    render(scrollTop) {
        const base = Scroll.getLimit().y - this.state.height

        if (base - 100 > scrollTop) {
            return
        }
        const ratio = Math.min(Math.max((scrollTop - base)/this.state.height, 0), 1)

        this.ref.wrapper.style.transform = `translateY(calc(${(ratio - 1) * 100}% - ${(ratio - 1) * 50}px)`
        this.ref.footer.style.opacity = ratio
    }

    check() {
        this.isPinned = this.state.height < window.innerHeight && !this.isForbidden
        if (this.isPinned) {
            this.element.classList.add(STATES.PINNED)
            this.element.style.height = `${this.state.height}px`
        } else {
            this.element.classList.remove(STATES.PINNED)
            this.element.removeAttribute('style')
            this.ref.wrapper.removeAttribute('style')
        }
    }
}